import React, { useContext, useEffect, useState } from "react";
import { Button, Box, IconButton, Stack, Typography } from "@mui/material";
import { PureLightThemeCaaS } from "src/theme/schemes/PureLightTheme";
import { WidgetContext } from "src/contexts/WidgetContext";
import TradeGiveReceive from "./TradeGiveReceive";
import CloseIcon from "@mui/icons-material/Close";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import styles from "../../content/pages/homepage.module.css";
import LoaderFacts from "../Loader/Loader";
import TradeGiveReceiveStream from "./TradeGiveReceiveStream";

function TradingPartnerListReceive({
  onClose,
  userDataPlatform,
  leagueIdPlatform,
  rostersData,
  loadingRoster,
  setErrorMessages,
  setShouldPlayAudio,
  aiSettings,
  setIsPaymentOpen,
  setInitialPaymentView,
  enableCreditValidation,
  calculatorSettings,
  selectedModel,
  setSelectedModel,
  userSubscription,
  setUserSubscription,
  setIsBenchDrawerOpen,
  characterRef,
  isExpanded,
  onToggleExpand,
  setThoughtsCommon,
  markSignThoughtsForDrawer,
  clearSignThoughtsDrawerSource,
  isCreditsAnimating,
  creditsBoxRef,
}) {
  // import of context function to make the team name dynamic
  const { handlePartnerSelect, selectedPartner } = useContext(WidgetContext);
  const [partnerSelected, setPartnerSelected] = useState(null);
  // const [isLoading, setIsLoading] = useState(true);

  const [teamDisplayName, setTeamDisplayName] = useState(null);
  const [userIdTeam, setUserIdTeam] = useState(null);
  const [ownerId, setOwnerId] = useState(null);

  const handlePartnerClick = (partner) => {
    setPartnerSelected(partner);
    // handlePartnerSelect(partner);
    setTeamDisplayName(partner);
  };

  const goBack = () => {
    setPartnerSelected(null);
    // setIsLoading(false);
  };

  const UserIdTeam = (userId, ownerId) => {
    setUserIdTeam(userId);
    setOwnerId(ownerId);
  };

  // console.log("teamsDisplayNAMEEEE", teamDisplayName);

  return (
    <>
      {loadingRoster ? (
        <LoaderFacts
          onClose={onClose}
          goBack={goBack}
          showExpandToggle={Boolean(aiSettings?.quan)}
          isExpanded={isExpanded}
          onToggleExpand={onToggleExpand}
        />
      ) : (
        <>
          {!partnerSelected && (
            <Stack direction="column" spacing={0} sx={{ width: "100%", bgcolor: `${PureLightThemeCaaS.colors.alpha.black[100]}`, paddingBottom: "env(safe-area-inset-bottom)" }}>
              <Stack direction="row" p={1} justifyContent="space-between" alignItems="center" borderBottom={`1px solid ${PureLightThemeCaaS.colors.alpha.white[30]}`}>
                <IconButton aria-label="close" onClick={onClose}>
                  <ArrowBackIcon sx={{ color: `${PureLightThemeCaaS.colors.alpha.white[100]}` }} />
                </IconButton>
                <Typography variant="h4" color={`${PureLightThemeCaaS.colors.alpha.white[100]}`} textAlign={"center"} className={styles.tradeTeam}>
                  Who do you want to trade with?
                </Typography>
                <Stack direction="row" spacing={0} alignItems="center">
                  {onToggleExpand && aiSettings?.quan && (
                    <IconButton aria-label="toggle-expand" onClick={onToggleExpand}>
                      {isExpanded ? (
                        <KeyboardArrowDownIcon sx={{ color: `${PureLightThemeCaaS.colors.alpha.white[100]}` }} />
                      ) : (
                        <KeyboardArrowUpIcon sx={{ color: `${PureLightThemeCaaS.colors.alpha.white[100]}` }} />
                      )}
                    </IconButton>
                  )}
                  <IconButton aria-label="close" onClick={onClose}>
                    <CloseIcon sx={{ color: `${PureLightThemeCaaS.colors.alpha.white[100]}` }} />
                  </IconButton>
                </Stack>
              </Stack>

              <Stack
                direction="column"
                spacing={1}
                sx={{
                  width: "100%",
                  p: 1,
                  boxSizing: "border-box",
                }}
              >
                {rostersData?.competitor_teams &&
                  rostersData?.competitor_teams.map((team) => (
                    <Button
                      key={team.team_id}
                      fullWidth
                      variant="contained"
                      disableElevation
                      data-testid="trade-partner-card"
                      data-trade-partner={team.team_name}
                      onClick={() => {
                        handlePartnerClick(team.team_name);
                        UserIdTeam(team.team_id, team?.owner?.owner_id);
                      }}
                      className={styles.tradeTeamName}
                      sx={{
                        position: "relative",
                        overflow: "hidden",
                        height: "70px",
                        borderRadius: "8px",
                        p: 0,
                        textTransform: "none",
                        // border: none resets all sides — re-apply borderLeft after it
                        border: "none !important",
                        borderLeft: "10px solid #555555 !important",
                        backgroundColor: "#222222",
                        boxShadow: "none !important",
                        "&:hover": {
                          border: "none !important",
                          borderLeft: "10px solid #555555 !important",
                          backgroundColor: "#222222",
                          boxShadow: "none !important",
                        },
                        "&:active, &.Mui-focusVisible": {
                          border: "none !important",
                          borderLeft: "10px solid #555555 !important",
                          boxShadow: "none !important",
                        },
                      }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "flex-start",
                          justifyContent: "center",
                          width: "100%",
                          px: 1.5,
                          gap: 0.25,
                        }}
                      >
                        {/* Same two-line layout as RostersListDisplay. Old: {team.team_name} / {team?.owner?.owner_name} */}
                        <Typography
                          sx={{
                            color: "#ffffff",
                            fontWeight: "bold",
                            fontSize: "24px",
                            textAlign: "left",
                            lineHeight: 1.2,
                            fontFamily: "Roboto Condensed",
                          }}
                        >
                          {team.team_name}
                        </Typography>
                        {team?.owner?.owner_name && (
                          <Typography
                            sx={{
                              color: "#FF672D",
                              fontWeight: "regular",
                              fontSize: "16px",
                              textAlign: "left",
                              lineHeight: 1.2,
                              // opacity: 0.85,
                              fontFamily: "Roboto Condensed",
                            }}
                          >
                            {team.owner.owner_name}
                          </Typography>
                        )}
                      </Box>
                    </Button>
                  ))}
              </Stack>
            </Stack>
          )}
        </>
      )}

      {/* Render TradeGiveReceive component if a partner is selected */}
      {partnerSelected && (
        <TradeGiveReceiveStream
          onClose={onClose}
          goBack={goBack}
          teamDisplayName={teamDisplayName}
          setErrorMessages={setErrorMessages}
          userIdTeam={userIdTeam}
          ownerId={ownerId}
          leagueIdPlatform={leagueIdPlatform}
          userDataPlatform={userDataPlatform}
          rostersData={rostersData}
          loadingRoster={loadingRoster}
          setShouldPlayAudio={setShouldPlayAudio}
          aiSettings={aiSettings}
          setIsPaymentOpen={setIsPaymentOpen}
          setInitialPaymentView={setInitialPaymentView}
          enableCreditValidation={enableCreditValidation}
          calculatorSettings={calculatorSettings}
          selectedModel={selectedModel}
          setSelectedModel={setSelectedModel}
          userSubscription={userSubscription}
          setUserSubscription={setUserSubscription}
          setIsBenchDrawerOpen={setIsBenchDrawerOpen}
          characterRef={characterRef}
          isExpanded={isExpanded}
          onToggleExpand={onToggleExpand}
          setThoughtsCommon={setThoughtsCommon}
          markSignThoughtsForDrawer={markSignThoughtsForDrawer}
          clearSignThoughtsDrawerSource={clearSignThoughtsDrawerSource}
          isCreditsAnimating={isCreditsAnimating}
          creditsBoxRef={creditsBoxRef}
        />
      )}
    </>
  );
}

export default TradingPartnerListReceive;
